import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Modal } from './modal';
import Typography from './Typography';
import { font } from '../constants/font';
import { STATIC_PATH } from '../constants/config';

// Styled Components
const ContentContainer = styled.div`
padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  position: relative;
`;

const IconContainer = styled.div`
  width: 48px;
  height: 48px;
  position: relative;
  flex-shrink: 0;
`;

const LoadingIcon = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-start;
  width: 100%;
  flex: 1;
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  font-family: 'Poppins', sans-serif;
  font-weight: bold;
  font-size: 18px;
  color: #313345;
  line-height: normal;
  flex: 1;
  min-height: 1px;
  min-width: 1px;
  width: 100%;
    justify-content: space-between;
`;

const ProgressBarContainer = styled.div`
  display: inline-grid;
  grid-template-columns: max-content;
  grid-template-rows: max-content;
  place-items: start;
  line-height: 0;
  flex-shrink: 0;
`;

const ProgressBar = styled.div`
  background: #E8EAEB;
  height: 12px;
  width: 348px;
  border-radius: 6px;
  margin: 0;
  margin-top: 0;
  grid-column: 1;
  grid-row: 1;
`;

const ProgressFill = styled.div`
  height: 12px;
  border-radius: 6px;
  margin: 0;
  margin-top: 0;
  grid-column: 1;
  grid-row: 1;
  transition: width 0.3s ease;
`;

const ReframeProgressModal = ({
  progress = 30,
  message = "Generating AI Reframe...",
  show = true,
  onClose
}) => {
  return (
    <Modal
      width="396px"
      height="163px"
      showModal={show}
      className="reframe-progress-modal"
      isRender={true}
      borderRadius="16px"
      onClose={onClose}
    >
      <ContentContainer>
        <IconContainer>
          <LoadingIcon src={`${STATIC_PATH}reframeProgress.svg`} alt="Loading" />
        </IconContainer>
        <TextContainer>
          <TitleContainer>
            <Typography
              innerContent={message}
              color="#313345"
              font={font.normal_18}
              cursor="pointer"
            />
            <Typography
              innerContent={`${progress}%`}
              color="#14B7FF"
              font={font.normal_18}
              cursor="pointer"
            />
          </TitleContainer>

          <ProgressBarContainer>
            <ProgressBar />
            <ProgressFill
              style={{
                width: `${progress}%`,
                background: progress > 0
                  ? 'linear-gradient(90deg, #64D6FF 0%, #B37BFF 50%, #FF6CD8 75%, #FF71D2 100%)'
                  : '#E8EAEB'
              }}
            />
          </ProgressBarContainer>
        </TextContainer>
      </ContentContainer>
    </Modal>
  );
};

ReframeProgressModal.propTypes = {
  progress: PropTypes.number,
  message: PropTypes.string,
  show: PropTypes.bool,
  onClose: PropTypes.func,
};

export default ReframeProgressModal;